import { render, staticRenderFns } from "./Offer.vue?vue&type=template&id=2d2d9057&scoped=true"
import script from "./Offer.vue?vue&type=script&lang=js"
export * from "./Offer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2d9057",
  null
  
)

export default component.exports